import React from 'react';

import { CONTAINER_ADMIN_HOME_ID } from '@confluence/app-navigation/entry-points/navigationIDs.ts';
import { SPACE_PERMISSIONS_SETTINGS } from '@confluence/named-routes/entry-points/routes.ts';
import type { RouteMatch } from '@confluence/route/entry-points/Route.ts';
import { Redirection } from '@confluence/route-manager/entry-points/Redirection.ts';

export const SpaceAnalyticsPermissionsRoute: {
	({ params: { spaceKey } }: RouteMatch): React.JSX.Element;
	NAVIGATION_PARAMS({ name, params: { spaceKey } }: RouteMatch): {
		Screen: {
			screenEvent: {
				name: string;
				id: string;
			};
			pageState: {
				routeName: string;
				spaceKey: string;
			};
		};
		MainLayout: {
			spaceKey: string;
			navView: string;
		};
	};
} = ({ params: { spaceKey } }: RouteMatch): React.JSX.Element => (
	<Redirection href={SPACE_PERMISSIONS_SETTINGS.toUrl({ spaceKey, tab: 'analytics' })} />
);

SpaceAnalyticsPermissionsRoute.NAVIGATION_PARAMS = ({
	name,
	params: { spaceKey },
}: RouteMatch): {
	Screen: {
		screenEvent: {
			name: string;
			id: string;
		};
		pageState: {
			routeName: string;
			spaceKey: string;
		};
	};
	MainLayout: {
		spaceKey: string;
		navView: string;
	};
} => ({
	Screen: {
		screenEvent: { name: 'spaceAnalyticsPermissions', id: spaceKey },
		pageState: { routeName: name, spaceKey },
	},
	MainLayout: {
		spaceKey,
		navView: CONTAINER_ADMIN_HOME_ID,
	},
});
